export default {"src":"/_next/static/media/ratingIcon.9a37b9f4.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};